import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mapState, mapActions } from 'vuex';
import Manager from '@/components/BumpEgg/Manager';
import { bus } from '@tencent/vft-vue-base';
import BumpModal from '@/components/BumpEgg/BumpModal/BumpModal';
import globalSetting from '@/setting';
var BUTTON_STATUS = {
  login: '立即登录',
  // 未登录
  open: '立即开通',
  // 不是VIP
  bump: '找老铁碰个蛋',
  // 有蛋
  mission: '做任务加蛋',
  // 今天已领取过蛋
  receive: '立即领取' // 今天未领取蛋

};

function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}

export default {
  name: 'EggInfo',
  components: {
    BumpModal: BumpModal,
    Manager: Manager
  },
  data: function data() {
    return {
      ready: false,
      defaultEggImg: window.setting.默认蛋图片,
      animatedEggCount: -1,
      doubleDayModal: false,
      receiveEggModal: false
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.alert({
                title: '活动已结束',
                msg: '您好，碰蛋活动已结束，感谢您的支持，您可以前往福利社参与更多精彩活动哦。',
                confirmText: '前往福利社',
                confirm: function confirm() {
                  location.replace('https://film.qq.com/x/welfare/');
                }
              }); // this.share.setShare(Object.assign({}, this.shareConfig))
              // alert(JSON.stringify(this.payVip, null, 2))

              _context.prev = 1;
              _context.next = 8;
              break;

            case 4:
              _context.prev = 4;
              _context.t0 = _context["catch"](1);
              this.alert(_context.t0.msg);
              throw _context.t0;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 4]]);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  computed: _objectSpread(_objectSpread({}, mapState('bump', {
    myEggInfo: function myEggInfo(state) {
      return state.myEggInfo ? state.myEggInfo : {
        egg_type: 0,
        egg_count: 0,
        special_id: ''
      };
    }
  })), {}, {
    eggButtonStatus: function eggButtonStatus() {
      if (!this.isLogin) {
        return BUTTON_STATUS.login;
      } else if (!this.payVip.vip && !globalSetting.活动逻辑.非会员可领) {
        if (this.myEggInfo.egg_count > 0) {
          return BUTTON_STATUS.bump;
        } else {
          return BUTTON_STATUS.open;
        }
      }

      if (this.myEggInfo) {
        if (this.myEggInfo.is_recved === 0) {
          return BUTTON_STATUS.receive;
        } else if (this.myEggInfo.egg_count > 0) {
          return BUTTON_STATUS.bump;
        } else {
          return BUTTON_STATUS.mission;
        }
      } else {
        // 兜底展示开通
        // 正常逻辑是不会走到这里的
        return BUTTON_STATUS.open;
      }
    },
    eggButtonImage: function eggButtonImage() {
      return this.setting[this.eggButtonStatus];
    },
    mainTitle: function mainTitle() {
      return this.myEggInfo.is_recved === 1 ? this.setting.领蛋主标题(this) : this.setting.未领蛋标题(this);
    },
    textHint: function textHint() {
      return this.isLogin ? '开通会员领取今日份彩蛋' : '登录查看今日份彩蛋';
    },
    showEggSkin: function showEggSkin() {
      var egg = this.myEggInfo;
      return egg && egg.egg_skin_url ? egg.egg_skin_url : this.defaultEggImg;
    },
    level: function level() {
      return this.payVip.level === 8 ? '星光' : "V".concat(this.payVip.level);
    },
    eggCount: function eggCount() {
      if (this.animatedEggCount >= 0) return this.animatedEggCount;
      return this.myEggInfo ? this.myEggInfo.egg_count : 0;
    },
    doubleDayModalButtons: function doubleDayModalButtons() {
      return {
        left: this.setting.真棒,
        leftAction: this.hideModal
      };
    },
    receiveEggModalButtons: function receiveEggModalButtons() {
      return {
        left: this.setting.真棒,
        leftAction: this.hideReceiveModal
      };
    },
    receiveEggSubTitle: function receiveEggSubTitle() {
      return this.setting.领蛋弹窗主标题(this);
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions('bump', ['init', 'receiveEgg'])), {}, {
    hideModal: function hideModal() {
      this.doubleDayModal = false;
    },
    hideReceiveModal: function hideReceiveModal() {
      this.receiveEggModal = false;
    },
    share: function share() {
      if (!this.isLogin) {
        this._openLogin();

        return;
      }

      this.$refs.manager.currentModal = this.$refs.manager.ModalType.Invite;
    },
    animate: function () {
      var _animate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.animatedEggCount = 0;

              case 1:
                if (!(++this.animatedEggCount <= this.myEggInfo.egg_count)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return sleep(200);

              case 4:
                _context2.next = 1;
                break;

              case 6:
                this.animatedEggCount = -1;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function animate() {
        return _animate.apply(this, arguments);
      }

      return animate;
    }(),
    eggButtonClick: function () {
      var _eggButtonClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = this.eggButtonStatus;
                _context3.next = _context3.t0 === BUTTON_STATUS.login ? 3 : _context3.t0 === BUTTON_STATUS.open ? 5 : _context3.t0 === BUTTON_STATUS.bump ? 7 : _context3.t0 === BUTTON_STATUS.mission ? 9 : _context3.t0 === BUTTON_STATUS.receive ? 11 : 24;
                break;

              case 3:
                this._openLogin();

                return _context3.abrupt("break", 24);

              case 5:
                bus.$emit('gotoTask');
                return _context3.abrupt("break", 24);

              case 7:
                this.share();
                return _context3.abrupt("break", 24);

              case 9:
                bus.$emit('gotoTask');
                return _context3.abrupt("break", 24);

              case 11:
                _context3.prev = 11;
                _context3.next = 14;
                return this.receiveEgg();

              case 14:
                res = _context3.sent;

                if (res.data.is_upgrade) {
                  this.doubleDayModal = true;
                } else {
                  this.receiveEggModal = true;
                }

                this.animate();
                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t1 = _context3["catch"](11);
                this.alert('领蛋失败！请稍后重试！');
                throw _context3.t1;

              case 23:
                return _context3.abrupt("break", 24);

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[11, 19]]);
      }));

      function eggButtonClick() {
        return _eggButtonClick.apply(this, arguments);
      }

      return eggButtonClick;
    }()
  }),
  settingKey: '领蛋模块',
  setting: {
    未领蛋标题: {
      type: 'expression',
      default: '亲爱的${level}会员，您今日彩蛋待领取',
      variables: ['level']
    },
    领蛋主标题: {
      type: 'expression',
      default: '亲爱的${level}会员，您的今日份彩蛋',
      variables: ['level']
    },
    领蛋副标题: '每日来领彩蛋，连续2天换金蛋',
    连续两天弹窗文案: '已连续领取2天，喜获镀金彩蛋',
    领蛋弹窗主标题: {
      type: 'expression',
      default: '亲爱的${level}会员，恭喜获得今日彩蛋',
      variables: ['level']
    },
    领蛋弹窗副标题: 'V7和星光会员每天可得3枚哦～',
    找老铁碰个蛋: 'https://puui.qpic.cn/vupload/0/20190625_1561468923541_5wyc0pu1x29.png/0',
    立即登录: 'https://puui.qpic.cn/vupload/0/20190625_1561468923542_t5xcbb7pkm.png/0',
    立即领取: 'https://puui.qpic.cn/vupload/0/20190625_1561468923540_4fqoa0n555o.png/0',
    立即开通: 'https://puui.qpic.cn/vupload/0/20190625_1561468923541_x7kid9bhmo.png/0',
    做任务加蛋: 'https://puui.qpic.cn/vupload/0/20190625_1561468923540_j40hrkxzqb.png/0',
    详细规则按钮: 'https://puui.qpic.cn/vupload/0/20190627_1561638204026_q3bq209sw7.png/0',
    真棒: 'https://puui.qpic.cn/vupload/0/20190705_1563178606464_m1kmx5bmlua.png/0'
  }
};